import SignUpService from '@/features/Auth/services/SignUpService';
import { TourService } from '@/features/Tour';

/**
 * Fecho do onboarding de usuário convidado (bug 84095): quem entrou por
 * convite já tem organização, então o fluxo termina após perfil/survey.
 * Marca a conclusão no backend, agenda o splash de boas-vindas (a org do
 * convidado já tem produtos, então o gate "org vazia" do dashboard não
 * dispararia o modal) e redireciona para o dashboard.
 */
export async function finishInvitedOnboarding(): Promise<void> {
  const response = await SignUpService.completeOnboarding();
  if (!response.success) {
    throw new Error(response.message || 'Failed to complete onboarding');
  }

  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('onboarding_profile');
    sessionStorage.removeItem('onboarding_survey');
    sessionStorage.removeItem('onboarding_organization');
    sessionStorage.removeItem('onboarding_avatar_preview');
    sessionStorage.removeItem('onboarding_logo_preview');
    TourService.markWelcomeTourPending();
    window.location.href = '/';
  }
}
